import React from "react";
import { withLocalize } from "react-localize-redux";
import { connect as connectFormik } from 'formik';
import { connect } from "react-redux";
import PopupMultiSelectButton from "../../common/popupMultiSelectButton";
import { bindActionCreators } from 'redux';
import { domainActions } from '../../../store/domainStore';
import BbFormikCheckbox from "../../styling/bbFormikCheckbox";
import BbCheckbox from "../../styling/bbCheckbox";
import BbRadioWrapper from '../../styling/BbRadioWrapper';
import BbInput from "../../styling/bbInput";
import { unicornAttributes } from "../../../store/marketingListStore";

class WarningsAndAdditionalInfo extends React.Component {
    componentDidMount(){
        this.props.formik.setFieldValue('warnings.details', true);
    }

    render() {
        return (
            <React.Fragment>
                <div className="columns">
                    <div className="column" style={{ display: "flex", flexWrap: "wrap" }}>
                        <BbCheckbox name="warnings.actual" disabled label={this.props.translate("Search.Marketing.OnlyActual")} id="warning-actual" value={true} onChange={() => { }} />
                        <BbFormikCheckbox name="warnings.historical" label={this.props.translate("Search.Marketing.AlsoHistorical")} id="warning-historical" />
                    </div>
                </div>
                <div className="columns">
                    <div className="column" style={{ display: "flex", flexWrap: "wrap" }}>
                        <BbRadioWrapper callback={() => this.props.formik.setFieldValue('warnings.details', false)}
                            checked={!this.props.formik.values.warnings.details}
                            id="details"
                            name="detail"
                            value="include" label={this.props.translate("Search.Marketing.Overview")} />
                        <BbRadioWrapper callback={() => this.props.formik.setFieldValue('warnings.details', true)}
                            checked={this.props.formik.values.warnings.details}
                            id="details-2"
                            name="detail"
                            value="include" label={this.props.translate("Search.Marketing.DetailInfo")} />
                    </div>
                </div>
                <BbInput type='custom' label={this.props.translate('Report.Warnings.SectionName')} placeholder={{ type: 'column' }} custom={
                    <PopupMultiSelectButton
                        horizontal
                        title={this.props.translate("Report.Warnings.SectionName")}
                        data='warning-types'
                        name='warning-types'
                        popupSize='large'
                        onClick={() => this.props.ensureDomainData('warning-types', { marketAttributes: unicornAttributes() })}
                        selection={this.props.formik.values.warnings.warnings}
                        handleChange={(all, parent) => {
                            this.checkIfAll("warning-types", "warnings.warnings", parent.length)
                            this.props.formik.setFieldValue('warnings.warnings.all', all);
                            this.props.formik.setFieldValue('warnings.warnings.parent', parent);
                        }}
                        splitOnlyParent={true}
                    />
                } />
                <BbInput type='custom' label={this.props.translate('Report.Warnings.SupplementaryInfo')} placeholder={{ type: 'column' }} custom={
                    <PopupMultiSelectButton
                        horizontal
                        title={this.props.translate("Report.Warnings.SupplementaryInfo")}
                        data='additional-info'
                        name='additional-info'
                        popupSize='large'
                        onClick={() => this.props.ensureDomainData('additional-info', { marketAttributes: unicornAttributes() })}
                        selection={this.props.formik.values.warnings.additional}
                        handleChange={(all, parent) => {
                            this.props.formik.setFieldValue('warnings.additional', { all: all, parent: parent });
                            this.checkIfAll("additional-info", "warnings.additional", parent.length);
                        }}
                        splitOnlyParent={true}
                    />
                } />
                <BbInput type='custom' label={this.props.translate('Search.Marketing.Liabilities')} placeholder={{ type: 'column' }} custom={
                    <PopupMultiSelectButton
                        horizontal
                        title={this.props.translate("Search.Marketing.Liabilities")}
                        data='sources'
                        name='sources'
                        popupSize='medium'
                        onClick={() => this.props.ensureDomainData('sources', { marketAttributes: unicornAttributes() })}
                        selection={this.props.formik.values.warnings.sources}
                        handleChange={(all, parent) => {
                            this.props.formik.setFieldValue('warnings.sources', { all: all, parent: parent });
                            this.checkIfAll("sources", "warnings.sources", parent.length);
                        }}
                    />
                } />
            </React.Fragment >
        )
    }
    checkIfAll(domain, field, length) {
        if (this.props.hasOwnProperty(domain) && this.props[domain].requestResult.length === length) {
            this.props.formik.setFieldValue(`${field}.allSelected`, true);
            return true;
        }
        this.props.formik.setFieldValue(`${field}.allSelected`, false);
        return false;
    }
}

export default withLocalize(connect(
    state => state.domain,
    dispatch => bindActionCreators(domainActions, dispatch)
)(connectFormik(WarningsAndAdditionalInfo)));



